import { Route } from '@angular/router';
import {
  EXCHANGE_ACCESS_ROLES,
  OPERATOR_ACCESS_ROLES,
  SALES_ACCESS_ROLES,
  SALES_AND_REFUNDS_ACCESS_ROLES,
} from '@app/core/services/http/auth/auth.service';

export const managementRoutes: Route = {
  path: 'management',
  children: [
    { path: '', pathMatch: 'full', redirectTo: 'exchange' },
    {
      path: 'exchange',
      data: {
        titleKey: 'components.adminLayout.sidebar.menu.exchanges',
        roles: [...EXCHANGE_ACCESS_ROLES],
      },
      loadComponent: () =>
        import('../../shared/section-placeholder/section-placeholder.component').then(
          m => m.SectionPlaceholderComponent
        ),
    },
    {
      path: 'refund',
      data: {
        titleKey: 'components.adminLayout.sidebar.menu.refundRequests',
        roles: [...SALES_AND_REFUNDS_ACCESS_ROLES],
      },
      loadComponent: () =>
        import('../../shared/section-placeholder/section-placeholder.component').then(
          m => m.SectionPlaceholderComponent
        ),
    },
    {
      path: 'sales/:certificateId',
      data: {
        titleKey: 'components.adminLayout.sidebar.menu.sales',
        roles: [...SALES_ACCESS_ROLES],
      },
      loadComponent: () =>
        import('./sales/sales-details/sales-details.component').then(m => m.SalesDetailsComponent),
    },
    {
      path: 'sales',
      data: {
        titleKey: 'components.adminLayout.sidebar.menu.sales',
        roles: [...SALES_ACCESS_ROLES],
      },
      loadComponent: () =>
        import('./sales/sales.component').then(m => m.SalesComponent),
    },
    {
      path: 'statistics',
      data: {
        titleKey: 'components.adminLayout.sidebar.menu.statistics',
        roles: [...OPERATOR_ACCESS_ROLES],
      },
      loadComponent: () =>
        import('../../shared/section-placeholder/section-placeholder.component').then(
          m => m.SectionPlaceholderComponent
        ),
    },
    {
      path: 'analytics',
      data: {
        titleKey: 'components.adminLayout.sidebar.menu.analytics',
        roles: [...OPERATOR_ACCESS_ROLES],
      },
      loadComponent: () =>
        import('./analytics/partner-sales-analytics.component').then(
          m => m.PartnerSalesAnalyticsComponent
        ),
    },
  ],
};
